import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";
import { InvalidArgumentError } from "utils/error";
import { orchid_encrypt } from "utils/OrchidEncryption";

import {
  orchidDriveDirectoryFromAPI,
  OrchidDriveDirectory,
  OrchidDriveEntryKeys,
  OrchidDriveUploadTask,
  orchidDriveUploadTaskFromAPI,
} from "../types";
import { createEntry } from "./entry";

export async function directoryEntryCreate(
  name: string,
  parentDirectoryId: string | null,
  storageDrive: StorageDrive,
  patientUserId: string | null,
  uploadTaskId: string | null,
  orchidUniqueDeviceId: string | null,
  abortController?: AbortController,
): Promise<{
  cipherKeys: OrchidDriveEntryKeys;
  directoryEntry: OrchidDriveDirectory;
  uploadTaskEntry: null | OrchidDriveUploadTask;
}> {
  if (!name) throw new InvalidArgumentError("directory name can't be empty");

  const cipherKeys = await createEntry(storageDrive, "directory");

  const response = await fetchOrchidAPI(
    `/api/drive_data/directory_entry/create_directory/${cipherKeys.entryId}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name_encrypted: await orchid_encrypt(
          name,
          cipherKeys.metaDataCipherKey,
        ),
        storage_drive: storageDrive,
        patient_user_id: patientUserId,
        parent_directory_id: parentDirectoryId,
        upload_task_id: uploadTaskId,
        orchid_unique_device_id: orchidUniqueDeviceId,
      }),
      signal: abortController?.signal,
    },
  );
  if (!response.ok) {
    const responseText = await response.text();
    throw new Error(getErrorDetail(responseText));
  }

  const responseData = await response.json();
  return {
    cipherKeys,
    directoryEntry: await orchidDriveDirectoryFromAPI(
      responseData.directory_entry,
      cipherKeys.metaDataCipherKey,
    ),
    uploadTaskEntry: responseData.upload_task
      ? orchidDriveUploadTaskFromAPI(responseData.upload_task)
      : null,
  };
}
